import { EventEmitter, Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class PopoverService {
  constructor() {}

  openPopover = new Subject<any>();
  closePopover = new Subject<any>();
  output = new Subject<any>();

  open() {
    this.openPopover.next(true);
  }

  close() {
    this.closePopover.next(true);
  }

  outputEvent(name, event) {
    this.output.next({ name: name, params: event });
  }
}
